var _circle, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _path2, _circle7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1184,
    height: 818,
    viewBox: "0 0 1184 818",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 846.814,
    cy: 531.237,
    r: 286.011,
    fill: "#A9DCE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94629 734.042C14.8436 571.538 280.523 666.977 280.523 409.035C280.523 120.141 708.705 357.447 845.414 347.13C954.781 338.876 1002.94 267.592 1015.66 158.833C1023.39 92.6276 1067.76 -29.9803 1183.32 9.22671",
    stroke: "#4F99B9",
    strokeWidth: 2,
    strokeDasharray: "2 4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 879.427,
    cy: 341.931,
    r: 5.08154,
    fill: "#4F99B9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.008,
    cy: 267.881,
    r: 5.08154,
    fill: "#4F99B9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.788,
    cy: 541.59,
    r: 5.08154,
    fill: "#4F99B9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.73,
    cy: 677.436,
    r: 5.08154,
    fill: "#4F99B9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1078.57,
    cy: 24.5742,
    r: 5.08154,
    fill: "#4F99B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M893.891 296.381C893.891 304.369 879.427 328.845 879.427 328.845C879.427 328.845 864.963 304.369 864.963 296.381C864.963 288.392 871.439 281.917 879.427 281.917C887.415 281.917 893.891 288.392 893.891 296.381Z",
    fill: "#4F99B9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 879.427,
    cy: 296.678,
    r: 8.70229,
    fill: "#7EC0CE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLine);
export default __webpack_public_path__ + "static/media/map-line.99c85fd6110e8493a9d4fe30bb3acd9f.svg";
export { ForwardRef as ReactComponent };